import request from "superagent";

import { getAuthHeader } from "../../utils/superagent";

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'query' implicitly has an 'any' type.
const fetchAllExperiences = async (query) => {
  try {
    const { body } = await request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .get(`${global.api}/hcpExperience?type=${query}`)
      .set(await getAuthHeader());
    return body;
    // FIXME: Automatically disabled during ESLint config update
  } catch {
    return [];
  }
};

export { fetchAllExperiences };
